angular.module('eStories.gift', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.gift', {
                url: 'gift',
                views: {
                    'mainView@': {
                        templateUrl: 'purchase/gift/gift.tmpl.html',
                        controller: 'GiftCtrl',
                        controllerAs: 'giftCtrl'
                    }
                }
            });
    }])

    //GiftCtrl

    .controller('GiftCtrl', [
        'ValidationModel',
        'AccountModel',
        '$scope',
        'BillingModel',
        'GA',
        '$location',

        function (ValidationModel, AccountModel, $scope, BillingModel, GA, $location) {

            var giftCtrl = this;

            GA.trackPageView($location.path());

        }])

    //GiftPurchaseCtrl

    .controller('GiftPurchaseCtrl', [
        'ValidationModel',
        'BillingModel',
        'AccountModel',
        '$scope',
        '$uibModalInstance',
        '$controller',
        'GiftModel',
        'LL',
        '$rootScope',

        function (ValidationModel, BillingModel, AccountModel, $scope, $uibModalInstance, $controller, GiftModel, LL, $rootScope) {

            AccountModel.refreshSavedPaymentDetails(function () {
                if (!AccountModel.savedPaymentDetails) {
                    $uibModalInstance.close();
                    AccountModel.resetPlanPurchaseProperties();
                    AccountModel.showUniversalUpdatePaymentDetailsModal();
                }
            }, function () {
                $uibModalInstance.close();
                AccountModel.showSignIn();
            });

            var giftPurchaseCtrl = this;
            giftPurchaseCtrl.account = AccountModel;

            $rootScope.giftModel = GiftModel;

            var purchaseCtrl = $controller('PurchaseCtrl', {$scope: $scope});
            angular.extend(this, purchaseCtrl);

            giftPurchaseCtrl.purchaseCtrl = purchaseCtrl;

            giftPurchaseCtrl.shouldShowUKInfo = function () {
                if (eStoriesUserlocation) {
                    return eStoriesUserlocation.code === "GB";
                }
            };

            giftPurchaseCtrl.openUpdatePaymentModal = function () {
                $uibModalInstance.close();
                AccountModel.updateGiftPurchaseDetails = true;

                AccountModel.showUniversalUpdatePaymentDetailsModal();
            };

            giftPurchaseCtrl.todaysDate = new Date();
            var today = new Date();
            giftPurchaseCtrl.expirationDate = today.setFullYear(today.getFullYear() + 5)

            giftPurchaseCtrl.closePurchaseConfirmation = function () {
                $uibModalInstance.close();
            };

            giftPurchaseCtrl.confirmGiftPayment = function () {
                if (!giftPurchaseCtrl.agreeToU) {
                    giftPurchaseCtrl.error = "Please agree to Terms and Conditions";
                    return;
                }
                $uibModalInstance.close();
                giftPurchaseCtrl.account.submitPurchaseGift();
            };

            giftPurchaseCtrl.checkIfPlanSelected = function (plan) {
                if (plan && GiftModel.selectedGiftPlan) {
                    return GiftModel.selectedGiftPlan.planId === plan.planId;
                }
            };

            giftPurchaseCtrl.submitGiftPurchase = function () {
                if (!giftPurchaseCtrl.agreeToU) {
                    giftPurchaseCtrl.error = "Please agree to Terms and Conditions";
                    return;
                }

                if (!GiftModel.selectedGiftPlan) {
                    giftPurchaseCtrl.error = "Please choose a gift type";
                    return;
                }
                $uibModalInstance.close();
                AccountModel.openPurchaseGiftModal();
                giftPurchaseCtrl.purchaseInProgress = true;

            };

            giftPurchaseCtrl.agreeToU = false;

            giftPurchaseCtrl.selectPlan = function (plan) {
                GiftModel.setSelectedGiftPlan(plan);
            };

            if (BillingModel.allPlanMap) {
                giftPurchaseCtrl.allPlanMap = BillingModel.allPlanMap;
            } else {
                BillingModel.getAllPlans(function (response) {
                    giftPurchaseCtrl.allPlanMap = response;
                });
            }
            giftPurchaseCtrl.tafBonusPlans = giftPurchaseCtrl.allPlanMap["TAF_BONUS"];
            safeApply($scope);


            giftPurchaseCtrl.showGiftTermsModal = function () {
                AccountModel.showGiftTermsModal();
            };

        }])

    //GiftRegistrationCtrl

    .controller('GiftRegistrationCtrl', [
        'ValidationModel',
        'AccountModel',
        '$scope',
        'BillingModel',
        '$uibModalInstance',
        'GiftModel',
        'LL',

        function (ValidationModel, AccountModel, $scope, BillingModel, $uibModalInstance, GiftModel, LL) {

            var giftRegistrationCtrl = this;

            giftRegistrationCtrl.closeModal = function () {
                $uibModalInstance.close();
            };

            giftRegistrationCtrl.shouldShowUKInfo = function () {
                if (eStoriesUserlocation) {
                    return eStoriesUserlocation.countryCode === "GB" || AccountModel.userDetails.countryCode === "GB";
                }
            };

            var today = new Date();
            giftRegistrationCtrl.minDate = today;
            giftRegistrationCtrl.sendDate = today;
            var md = new Date();
            var today = new Date();
            giftRegistrationCtrl.maxDate = md.setFullYear(md.getFullYear() + 1);

            giftRegistrationCtrl.giftSenderName = GiftModel.giftSenderName ? GiftModel.giftSenderName : null;
            giftRegistrationCtrl.name = GiftModel.name ? GiftModel.name : null;
            giftRegistrationCtrl.email = GiftModel.email ? GiftModel.email : null;
            giftRegistrationCtrl.message = GiftModel.message ? GiftModel.message : null;
            giftRegistrationCtrl.creditGiftPlanPricingId = GiftModel.creditGiftPlanPricingId ? GiftModel.creditGiftPlanPricingId : null;

            giftRegistrationCtrl.disablePreview = function () {
                return !(giftRegistrationCtrl.giftSenderName != null &&
                    giftRegistrationCtrl.email != null &&
                    giftRegistrationCtrl.name != null);
            };

            giftRegistrationCtrl.formErrors = {};

            giftRegistrationCtrl.freeOfErrors = function () {
                var obj = giftRegistrationCtrl.formErrors;
                return Object.keys(obj).length === 0 && JSON.stringify(obj) === JSON.stringify({});
            };

            giftRegistrationCtrl.validateFullName = function (fullName) {
                return ValidationModel.validateFullName(fullName, giftRegistrationCtrl.formErrors);
            };

            giftRegistrationCtrl.validateEmail = function (email) {
                return ValidationModel.validateEmail(email, giftRegistrationCtrl.formErrors);
            };

            giftRegistrationCtrl.validatePassword = function (password) {
                return ValidationModel.validatePassword(password, giftRegistrationCtrl.formErrors);
            };

            giftRegistrationCtrl.validateConfirmEmail = function (email, confirmEmail) {
                return ValidationModel.validateConfirmEmail(email, confirmEmail, giftRegistrationCtrl.formErrors);
            };

            giftRegistrationCtrl.getFieldClass = function (fieldName, fieldValue, isTypingInProgress) {
                return ValidationModel.getFieldClass(fieldName, fieldValue, giftRegistrationCtrl.formErrors, isTypingInProgress);
            };

            giftRegistrationCtrl.displayPurchaseGiftError = function (error) {
                giftRegistrationCtrl.purchaseGiftError = error;
            };

            giftRegistrationCtrl.freeOfErrors = function () {
                var obj = giftRegistrationCtrl.formErrors;
                return Object.keys(obj).length === 0 && JSON.stringify(obj) === JSON.stringify({});
            };


            giftRegistrationCtrl.previewGiftMessage = function () {
                if (!giftRegistrationCtrl.freeOfErrors()) {
                    return;
                }
                GiftModel.giftSenderName = giftRegistrationCtrl.giftSenderName;
                GiftModel.name = giftRegistrationCtrl.name;
                GiftModel.email = giftRegistrationCtrl.email;
                GiftModel.message = giftRegistrationCtrl.message;
                GiftModel.creditGiftPlan = giftRegistrationCtrl.creditGiftPlanPricingId;
                GiftModel.creditGiftPlanPricingId = giftRegistrationCtrl.creditGiftPlanPricingId;

                return AccountModel.showConfirmGiftMessageModal();
            };


            giftRegistrationCtrl.validateSendDate = function (sendDate) {
                if (giftRegistrationCtrl.sendDate >= giftRegistrationCtrl.maxDate || giftRegistrationCtrl.sendDate <= giftRegistrationCtrl.minDate) {
                    return giftRegistrationCtrl.purchaseGiftError = "Send date of gift must be a valid date between today and one year from today";
                } else {
                    return true;
                }
            };

            giftRegistrationCtrl.submitGiftRegistration = async function () {
                if (!giftRegistrationCtrl.freeOfErrors()) {
                    return;
                }

                if ((giftRegistrationCtrl.sendDate.setHours(0, 0, 0, 0)) === (today.setHours(0, 0, 0, 0))) {
                    giftRegistrationCtrl.sendDate = null;
                }

                giftRegistrationCtrl.validateSendDate(giftRegistrationCtrl.sendDate);

                giftRegistrationCtrl.purchaseInProgress = true;
                GiftModel.giftSenderName = giftRegistrationCtrl.giftSenderName;
                GiftModel.name = giftRegistrationCtrl.name;
                GiftModel.email = giftRegistrationCtrl.email;
                GiftModel.message = giftRegistrationCtrl.message;
                GiftModel.creditGiftPlanPricingId = giftRegistrationCtrl.creditGiftPlanPricingId;
                GiftModel.sendDate = giftRegistrationCtrl.sendDate ? giftRegistrationCtrl.sendDate : null;

                $uibModalInstance.close();

                try {
                    await AccountModel.getSavedPaymentDetails();
                    try {
                        const response = await BillingModel.purchaseGift(GiftModel.selectedGiftPlan.planPricingId, GiftModel.giftSenderName, GiftModel.name, GiftModel.email, GiftModel.message, GiftModel.sendDate);
                        giftRegistrationCtrl.purchaseInProgress = false;
                        safeApply($scope);
                        if (response.responseText === "SUCCESS") {
                            $uibModalInstance.close();
                            AccountModel.refreshSubscriptionDetails();
                            GiftModel.setPurchasedGiftPlan();
                            var oneDay = 24 * 60 * 60 * 1000;
                            var todaysDate = new Date();
                            var sendDate = GiftModel.sendDate ? GiftModel.sendDate : todaysDate;
                            var diffDays = Math.round(Math.abs((todaysDate.getTime() - sendDate.getTime()) / (oneDay)));
                            var llAttributes = {
                                paymentMethod: AccountModel.savedPaymentDetails ? AccountModel.savedPaymentDetails.paymentMethod : null,
                                numberOfBooksPurchased: GiftModel.purchasedGiftPlan.packageList[0].credits,
                                daysUntilSend: diffDays,
                                sendDate: GiftModel.sendDate ? GiftModel.sendDate : "immediately"
                            };
                            LL.tagEvent('Gift Purchase', llAttributes);
                            GiftModel.clearGiftRegistration();
                            return AccountModel.showPostGiftPurchaseModal();
                        } else {
                            giftRegistrationCtrl.error = 'Oops, we can\'t processs your payment.  An error has occurred.';
                            giftRegistrationCtrl.purchaseInProgress = false;
                            safeApply($scope);
                        }
                    } catch (error) {
                        giftRegistrationCtrl.error = BillingModel.getPurchaseError(error.responseText);
                        giftRegistrationCtrl.error = 'Oops, we can\'t processs your payment.  An error has occurred.';
                        giftRegistrationCtrl.purchaseInProgress = false;
                        safeDigest($scope);
                    }
                } catch (error) {
                    // show the update details modal before continuing
                    giftRegistrationCtrl.error = 'Oops, we can\'t processs your payment.  An error has occurred.';
                    giftRegistrationCtrl.purchaseInProgress = false;
                    safeApply($scope);
                }
            }
        }])

    //GiftTermsCtrl

    .controller('GiftTermsCtrl', [
        'ValidationModel',
        'AccountModel',
        '$scope',
        'BillingModel',
        '$uibModalInstance',

        function (ValidationModel, AccountModel, $scope, BillingModel, $uibModalInstance) {

            var giftTermsCtrl = this;

            giftTermsCtrl.closeModal = function () {
                $uibModalInstance.close();
            }


        }])

    //IneligibleGiftCtrl

    .controller('IneligibleGiftCtrl', [
        'ValidationModel',
        'AccountModel',
        '$scope',
        'BillingModel',
        '$uibModalInstance',

        function (ValidationModel, AccountModel, $scope, BillingModel, $uibModalInstance) {

            var ineligibleGiftCtrl = this;

            ineligibleGiftCtrl.closeModal = function () {
                $uibModalInstance.close();
            };

        }])

    //RedeemGiftCtrl

    .controller('RedeemGiftCtrl', [
        'ValidationModel',
        'AccountModel',
        '$scope',
        'BillingModel',
        '$uibModalInstance',
        'GiftModel',

        function (ValidationModel, AccountModel, $scope, BillingModel, $uibModalInstance, GiftModel) {

            var redeemGiftCtrl = this;

            redeemGiftCtrl.todaysDate = new Date();

            var today = new Date();

            redeemGiftCtrl.expirationDate = today.setFullYear(today.getFullYear() + 5);

            AccountModel.getGiftDetails();

            redeemGiftCtrl.closeModal = function () {
                $uibModalInstance.close();
            };

            redeemGiftCtrl.acceptGift = function () {
                AccountModel.acceptGift();
            };

            redeemGiftCtrl.signUpOrConfirmTrial = function () {
                $uibModalInstance.close();
                AccountModel.signUpOrConfirmTrial();
            };

            redeemGiftCtrl.signInOrConfirmTrial = function () {
                $uibModalInstance.close();
                AccountModel.signInOrConfirmTrial();
            };

        }])

    //GiftTermsCtrl

    .controller('GiftTermsCtrl', [
        'ValidationModel',
        'AccountModel',
        '$scope',
        'BillingModel',
        '$uibModalInstance',

        function (ValidationModel, AccountModel, $scope, BillingModel, $uibModalInstance) {

            var giftTermsCtrl = this;

            giftTermsCtrl.closeModal = function () {
                $uibModalInstance.close();
            }


        }])

    //PreviewGiftCtrl

    .controller('PreviewGiftCtrl', [
        '$scope',
        'BillingModel',
        'GiftModel',
        '$uibModalInstance',


        function ($scope, BillingModel, GiftModel, $uibModalInstance) {

            var previewGiftCtrl = this;

            previewGiftCtrl.closeModal = function () {
                $uibModalInstance.close();
            };

        }]);



